export function createReferenceFromClick(nativeEvent) {
  var left = nativeEvent.clientX;
  var top = nativeEvent.clientY;
  var right = left + 1;
  var bottom = top + 1;
  function getBoundingClientRect() {
    return {
      left: left,
      top: top,
      right: right,
      bottom: bottom,
      height: 0,
      width: 0
    };
  }
  return {
    getBoundingClientRect: getBoundingClientRect
  };
}
//# sourceMappingURL=createReferenceFromClick.js.map
